import { combineReducers } from 'redux';
// import { persistReducer } from 'redux-persist';
// import storage from 'redux-persist/lib/storage';
// import hardSet from 'redux-persist/lib/stateReconciler/hardSet';

import testPageDataReducer from './testPageDataReducer';
import testPageUIReducer from './testPageUIReducer';

// const authDataPersistConfig = {
//   key: 'data',
//   storage,
//   stateReconciler: hardSet,
// };

export default combineReducers({
  ui: testPageUIReducer,
  data: testPageDataReducer,
});
